module.exports = __webpack_public_path__ + "img/slogan.07b1eab1.png";